const articleData = {
  title: 'Article title',
  img: 'https://source.unsplash.com/random',
  body: 'here is the article body',
};

export default articleData;
